module.exports = __webpack_public_path__ + "img/itx-text-h5.2f8ac3e9.svg";